var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invitation-button-container",class:{'invitation-button-disabled': _vm.disabled},on:{"click":_vm.callAction}},[_c('span',{staticClass:"material-icons-outlined"},[_vm._v(_vm._s(_vm.icon))]),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }